module.exports = __webpack_public_path__ + "static/Epson-8bdcd01fffa28f318472fb8d46e93fb7.svg";